module.exports = __webpack_public_path__ + "static/media/AdobeCC_Step2b_Image4c.8eac85aa.jpg";